import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ScheduleData from 'shared/data/Schedule';
import ListData from 'shared/data/List';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';
import { DisplayTypes } from 'shared/constants/FlowConstants';

let async = { asyncResult: true };

const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);
const readOnlyCfg = readOnlyHelper.actionConfigFactory();

let EventShowListActions = Reflux.createActions({
  populate: async,
  populateForGuest: async,
  toggleEdit: readOnlyCfg,
  cancelEdit: {},
  archive: asyncReadOnlyCfg,
  hardDelete: asyncReadOnlyCfg,
  hardDeleteSaved: asyncReadOnlyCfg,
  duplicate: asyncReadOnlyCfg,
  createSavedVersion: asyncReadOnlyCfg,
  createTemplate: asyncReadOnlyCfg,
  createFromTemplate: asyncReadOnlyCfg,
  restoreArchiveTemplate: asyncReadOnlyCfg,
  archiveTemplate: asyncReadOnlyCfg,
  restoreTemplate: asyncReadOnlyCfg,
  hardDeleteTemplate: asyncReadOnlyCfg,
  createFromSavedVersion: asyncReadOnlyCfg,
  restore: async,
});

EventShowListActions.populate.listenAndPromise(ShowData.getByEventId);

EventShowListActions.populateForGuest.listenAndPromise(
  ShowData.getByEventIdForGuest,
);

EventShowListActions.hardDelete.listenAndPromise(ShowData.hardDelete);
EventShowListActions.archive.listenAndPromise(ShowData.archive);
EventShowListActions.archiveTemplate.listenAndPromise(ShowData.archiveTemplate);
EventShowListActions.restoreTemplate.listenAndPromise(ShowData.restoreTemplate);
EventShowListActions.hardDeleteSaved.listenAndPromise(ShowData.hardDelete);
EventShowListActions.hardDeleteTemplate.listenAndPromise(ShowData.hardDelete);

EventShowListActions.createFromTemplate.listenAndPromise(
  (teamId, eventId, show, template, displayType) => {
    var handler = ShowData.create;

    if (displayType === DisplayTypes.schedule) handler = ScheduleData.create;
    if (displayType === DisplayTypes.list) handler = ListData.create;

    return handler(teamId, eventId, show, template);
  },
);

EventShowListActions.restore.listenAndPromise(
  (teamId, eventId, showId, displayType) => {
    var handler = ShowData.restore;

    if (displayType === DisplayTypes.schedule) handler = ScheduleData.restore;
    if (displayType === DisplayTypes.list) handler = ListData.restore;

    return handler(teamId, eventId, showId);
  },
);

EventShowListActions.createFromSavedVersion.listenAndPromise(
  (teamId, eventId, showId, displayType) => {
    var handler = ShowData.createFromSavedVersion.bind(ShowData);

    if (displayType === DisplayTypes.schedule)
      handler = ScheduleData.createFromSavedVersion.bind(ScheduleData);

    if (displayType === DisplayTypes.list)
      handler = ListData.createFromSavedVersion.bind(ListData);

    return handler(teamId, eventId, showId);
  },
);

EventShowListActions.createTemplate.listenAndPromise(
  (teamId, eventId, showId, templateTitle, displayType) => {
    var handler = ShowData.createTemplate.bind(ShowData);

    if (displayType === DisplayTypes.schedule)
      handler = ScheduleData.createTemplate.bind(ScheduleData);

    if (displayType === DisplayTypes.list)
      handler = ListData.createTemplate.bind(ListData);

    return handler(teamId, eventId, showId, templateTitle);
  },
);

EventShowListActions.createSavedVersion.listenAndPromise(
  (teamId, eventId, showId, displayType) => {
    var handler = ShowData.createSavedVersion.bind(ShowData);

    if (displayType === DisplayTypes.schedule)
      handler = ScheduleData.createSavedVersion.bind(ScheduleData);

    if (displayType === DisplayTypes.list)
      handler = ListData.createSavedVersion.bind(ListData);

    return handler(teamId, eventId, showId);
  },
);

EventShowListActions.duplicate.listenAndPromise(
  (teamId, eventId, showId, displayType, parentId) => {
    var handler = ShowData.duplicate.bind(ShowData);

    if (displayType === DisplayTypes.schedule)
      handler = ScheduleData.duplicate.bind(ScheduleData);

    if (displayType === DisplayTypes.list)
      handler = ListData.duplicate.bind(ListData);

    return handler(teamId, eventId, showId, false, undefined, parentId);
  },
);

export default EventShowListActions;
